import { actionCreatorFactory } from 'typescript-fsa';
import { INotificationEntry } from './notification.interface';

export namespace NotificationAction {
  const actionCreator = actionCreatorFactory('Notification');

  export const show = actionCreator<INotificationEntry>('SHOW');
  export const close = actionCreator<{ key: string }>('CLOSE');

  export const destroy = actionCreator('DESTROY');
}
